import { render, staticRenderFns } from "./ListQualification.vue?vue&type=template&id=5b2a1245&"
import script from "./ListQualification.vue?vue&type=script&lang=js&"
export * from "./ListQualification.vue?vue&type=script&lang=js&"
import style0 from "./ListQualification.vue?vue&type=style&index=0&id=5b2a1245&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports